const executionChainMixin = {
  data () {
    return {
      executionChainController: {
        methodList: [],
        index: 0,
        launch: function () {
          this.methodList[0](this);
        },
        next: function () {
          if (this.index < (this.methodList.length - 1)) {
            this.methodList[++this.index](this);
          }
        },
      },
    };
  },
  methods: {
    executionChainMixinSetMethodList (list) {
      this.executionChainController.methodList = list;
    },
  },
};

export default executionChainMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/executionChain.js